import { UseMutateAsyncFunction, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { DeleteCommentRequestParams, queryClient } from 'api';
import { API_HANDLERS } from 'api/apiHandlers';

interface UseDeleteCommentMutationProps {
  invalidateQueries?: string[];
  onSuccessAction?: () => void;
}

interface UseDeleteCommentMutationReturn {
  deleteCommentMutation: UseMutateAsyncFunction<
    AxiosResponse<unknown, unknown>,
    unknown,
    DeleteCommentRequestParams,
    unknown
  >;
  isLoading: boolean;
}

export function useDeleteCommentMutation({
  invalidateQueries,
  onSuccessAction,
}: UseDeleteCommentMutationProps): UseDeleteCommentMutationReturn {
  const { mutateAsync: deleteCommentMutation, isLoading } = useMutation(
    API_HANDLERS.COMMENTS.DELETE_COMMENT,
    {
      onSuccess: () => {
        invalidateQueries && queryClient.invalidateQueries(invalidateQueries);
        onSuccessAction?.();
      },
    },
  );

  return {
    deleteCommentMutation,
    isLoading,
  };
}
